import React from 'react';
import { useI18n } from '@goparrot-dashboard/i18n';
import { SsoSignInButton } from './SsoSignInButton';

export const SsoSignInButtonWrapper: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { getIntlString } = useI18n();

  return (
    <section className={'tw-pt-8'} role="presentation">
      <p className={'tw-pt-6 tw-border-t tw-border-1 tw-text-base'} role="note">
        {getIntlString('cta.ssoSignIn')}
      </p>
      <SsoSignInButton />
    </section>
  );
};
